module.exports = __webpack_public_path__ + "static/media/logo-1.c3b177f6.png";